var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog","appear":""}},[_c('div',{staticClass:"dialog-mask",on:{"click":_vm.close}},[_c('div',{staticClass:"dialog-wrapper"},[_c('div',{staticClass:"dialog-container",style:({width: _vm.dialogWidth}),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-085ccc64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/dialog.vue
// module id = null
// module chunks = 